// Lib
import React from 'react';
import Spinner from '../loaders/Spinner';

// Styles
import './LoadablePopupSpinner.scss';

const LoadablePopupSpinner = () => (
    <div className="LoadablePopupSpinner">
        <Spinner show />
    </div>
);

export default LoadablePopupSpinner;
